import service from './axios'

/**
 * * 获取文件的编辑地址
 * @param {number} docSource 项目文档:0   底稿文档:1   客户文档:2   个人网盘文档:8
 * @param {number} fileId 每个对应文档下文件的id
 * @param {string} type 文字文件:w, 表格文件:s, 演示文件:p, PDF文件:f
 * @returns { url }
 */
export const getFileUrl = data =>
  service({
    url: '/doc/online/edit/getOnlineEditUrl',
    method: 'post',
    data
  })

/**
 * * 聊天来源获取在线编辑数据
 * @param {*} data 
 * @returns 
 */
export const getChartFileUrl = data =>
  service({
    url: '/im/chat/file/getOnlineEditUrl',
    method: 'post',
    data
  })

/**
 * * 根据文件Id查询锁状态
 * @param {string} docId 文件Id
 * @returns
 */
export const getLockInfo = data =>
  service({
    url: '/doc/online/edit/getLockInfo',
    method: 'post',
    data
  })

/**
 * * 轮询查看系统数据
 * @param {string} docId
 * @param {string} orgId
 * @param {string} docSource
 * @param {string} crmId
 * @param {string} version
 * @returns
 */
export const getPollingData = data =>
  service({
    url: '/doc/online/edit/getWpsOnlineErrLog',
    method: 'post',
    data
  })

// * 下载
export const downloadChatFile = data =>
  service({
    url: '/im/chat/file/downloadChatFile',
    method: 'post',
    data
  })

// * 复制预览那边的方法
export const downloadPath = (data) => service({
  url: data.url,
  method: 'post',
  data
})

// * 解锁
export const setUnlock = (docSource, data) => {
  let url = ''
  //项目文档:0   底稿文档:1   客户文档:2
  if (docSource === 0) {
    /**
     * @params  docId
     */
    url = '/doc/project/setDocUnLock'
  } else if (docSource === 1) {
    /**
     * @params  docId
     * @params  projId
     */
    url = '/doc/paper/setDocUnLock'
  } else if (docSource === 2) {
    /**
     * @params  docId
     */
    url = '/doc/crm/setDocUnLock'
  }
  return service({
    url,
    method: 'post',
    data
  })
}

// * 查询在线编辑支持的类型
export const getSupportFileType = () => 
  service({
    url: '/doc/online/edit/getWpsOnlineFormat',
    method: 'post',
  })

// 批量建立文件夹，前端分批传输数据
export const batchSaveFoldersData = (data) => service({
  url: '/file/onlineFunction/batchSaveFoldersData',
  method: 'post',
  data
})




// WEBPACK FOOTER //
// ./src/api/onlineEdit.api.js